export default __webpack_public_path__ + "static/media/user.e33d83f6.svg";